/* eslint camelcase: 0 */
/* global screenfull, ADB, s_pageview_id, s_md, wmdSetContext, wmdRemContext, remLinkTrackVars, addLinkTrackVars, wmdPageLink */
import HBT                          from '../../ext_libraries/heartbeat/VideoHeartbeat.min.js';
import { isMobile }                 from 'utils/util.js';
import { defaults, camelCase,
        keys, assign, get }         from 'lodash';
import Reflux                       from 'reflux';
import HasMedscapeGlobals           from 'mixins/has_medscape_globals';
import HasPrettyTime                from 'mixins/has_pretty_time';
import VideoStore                   from 'stores/video_store';
import CMETracking                  from 'mixins/tracking';
import TrackingActions              from 'actions/tracking_actions';
import VideoActions                 from 'actions/video_actions';


export default Reflux.createStore({
  listenables: TrackingActions,
  mixins: [ HasMedscapeGlobals, HasPrettyTime, CMETracking ],
  isFirstPlay: true,
  isWaiting: false,
  hasStarted: false,
  hasEnded: false,
  init() {
    this.contextDataVars = [
      'contextData.a.contentType',
      'contextData.a.media.name',
      'contextData.a.media.playerName',
      'contextData.a.media.pageName',
      'contextData.a.media.friendlyName',
      'contextData.a.media.length',
      'contextData.a.media.channel',
      'contextData.a.media.view',
      'contextData.a.media.ad.name',
      'contextData.a.media.ad.podFriendlyName',
      'contextData.a.media.ad.length',
      'contextData.a.media.ad.pod',
      'contextData.a.media.ad.podPosition',
      'contextData.a.media.ad.podSecond',
      'contextData.a.media.ad.CPM',
      'contextData.a.media.ad.view',
      'contextData.a.media.extcampaign',
      'contextData.wb.vpgnm',
      'contextData.wb.ecd',
      'contextData.wb.vdname'
    ];
    this.initMedscapeGlobals();
    this.$wmdPageView(window.location.href, 1);
    this.isCPDisabled   = (typeof this.cp === 'undefined') ? true: false;
    this.isIPPDisabled  = true;
    this.$metrics.prop6 = 'video-medscapetv';
    this.listenTo(VideoStore, this.onVideoChange.bind(this));
    if(typeof wmdSetContext !== 'undefined' && typeof remLinkTrackVars !== 'undefined') {
      wmdSetContext('wb.chn', this.getWBChn());
      wmdSetContext('wb.contype', 'video - mtv');
      wmdSetContext('wb.toolin', 'video - mtv');
    }
    this.makeIppParticipationCall();
    window.trackingEnabled = true;
  },
  onRouteChange() {
    this.$wmdPageView(window.location.href, 1);
  },
  makeIppParticipationCall() {
    const event = {
          tacticId: get(this, 'ipp.tacticId', ''),
        activityId: get(this, 'ipp.activityId', ''),
           appname: 'mtvevent',
      activityName: 'participation'
          };
    if(typeof window.postCp !== 'undefined') {
      window.postCp(event);
    }
  },
  makeIppContentCall(activityName) {
    const event = {
          tacticId: get(this, 'ipp.tacticId', ''),
        activityId: get(this, 'ipp.activityId', ''),
           appname: 'mtvcontent',
      activityName: activityName
          };
    if(typeof window.postCp !== 'undefined') {
      window.postCp(event);
    }
  },
  resetDurationTracking() {
    this.percentages = { [25]: true, [50]: true, [75]: true };
  },
  onVideoChange(state) {
    const { event } = state.video,
            handler = camelCase(`on_${event}`);
    if(this[handler]) {
      this[handler](state.video);
    }
  },
  onSelectVideo(media) {
    this.pageLink(media);
  },
  onSocialMedia(media) {
    this.pageLink(`${window.MedscapeTVInstance.seriesUrlFragment}/soc_bpm${media}-v`);
  },
  onSlideNavigate(direction) {
    this._metrics(`show_${direction}`);
  },
  onSectionScrollView(section) {
    this._metrics(`module_${section}`);
  },
  // small_d
  onTranscriptOpen() {
    this._metrics(`trnscrpt_open`);
  },
  onInternalLink() {
    this._metrics(`intlink`);
  },
  onExternalLink() {
    this._metrics(`exlink`);
  },
  onShowMore() {
    this._metrics(`more`);
  },
  onShowLess() {
    this._metrics(`less`);
  },
  onCommentsOpen() {
    this._metrics(`comments_open`);
  },
  onTranscriptClose() {
    this._metrics(`trnscrpt_close`);
  },
  onCommentsClose() {
    this._metrics(`comments_close`);
  },
  onVideoSelected() {
    if(!this.isFirstPlay && this.heartbeat) {
      if(this.heartbeat._isDestroyed !== false) {
        if(this.analyticsPlugin) {
          this.analyticsPlugin.setAdMetadata(null);
          this.analyticsPlugin.setVideoMetadata(null);
        }
        if(this.VideoPlayerPlugin) {
          this.VideoPlayerPlugin.trackVideoUnload();
          this.heartbeat.destroy();
        }
        this.hasEnded = false;
      }
    }
    this.hasStarted = false;
    this.hasEnded = false;
    this.isFirstPlay = false;
  },
  setVideoMetadata() {
    const video = window.MedscapeTVInstance.videos.filter((inVideo)=> {
      return VideoStore.state.meta.videoUrlFragment === inVideo.videoUrlFragment;
    });
    const videoIndex = (typeof video[0].videoIndex !== 'undefined')?('0' + (parseInt(video[0].videoIndex, 10) + 1)).slice(-2):'Ifi';
    const contentString = `s01e${videoIndex}`;
    this.makeIppContentCall(contentString);
    s_md.pageName = (document.location.host.replace('www.', '') + document.location.pathname);
    s_md.eVar1 = (document.location.host.replace('www.', '') + document.location.pathname);
    s_md.pageURL = (document.location.href);
    s_md.prop7 = (document.location.pathname.substring(1));
    this.analyticsPlugin.setVideoMetadata({
            vdname: VideoStore.getTitle(),
               chn: this.getWBChn(),
                rs: s_md.prop50 || '',
              site: s_md.prop3,
             topic: s_md.eVar4  || s_md.prop4 || '',
           dprofsn: s_md.prop19 || '',
           dspclty: s_md.prop38 || '',
             regid: s_md.prop47 || '',
            dcntry: s_md.prop37 || '',
            toolin: 'video - mtv',
          pageName: (document.location.host.replace('www.', '') + document.location.pathname),
       extcampaign: (typeof s_md.contextData['wb.ecd'] !== 'undefined')?s_md.contextData['wb.ecd'] :''
    });
  },
  onPaused(state) {
    // this is getting triggered at the end of the vid.
    if(state.duration !== state.currentTime && this.VideoPlayerPlugin) {
      if(this.VideoPlayerPlugin._isDestroyed !== true) {
        this.VideoPlayerPlugin.trackPause();
      }
    }
  },
  onPlay(state) {
    const  isStart     = !this.hasStarted && !this.hasEnded,
            autoplay   =  get(state, 'meta.autoplay', true);

//    console.log('hasStarted', this.hasStarted);
//    console.log('hasEnded', this.hasEnded);
//           isReplay  = !this.hasStarted && this.hasEnded,
//         isCompleted = this.hasStarted && this.hasEnded;
    if(isStart) {
      this.addHeartbeatContext();
      this.initHeartbeat();
      this.remHeartbeatContext();
      this.hasStarted = true;
      this.hasEnded   = false;
      this.remHeartbeatContext();
      this._metrics('start', { prop9: 'allvideo_start' }, '_');
      this.resetDurationTracking();
      this.VideoPlayerPlugin.trackVideoLoad();
      this.VideoPlayerPlugin.trackSessionStart();
      if(!autoplay) {
        this._metrics('ctl_play');
      }
    }
    this.VideoPlayerPlugin.trackPlay();
  },
  onEnded() {
    if(this.hasEnded !== true) {
      this._metrics('100pct', { prop9: 'allvideo_100pct' }, '_');
      if(this.chapter) {
        this.analyticsPlugin.setChapterMetadata(null);
        this.VideoPlayerPlugin.trackChapterComplete();
      }
      this.analyticsPlugin.setAdMetadata(null);
      this.analyticsPlugin.setVideoMetadata(null);
      this.VideoPlayerPlugin.trackComplete();
      this.VideoPlayerPlugin.trackVideoUnload();
      this.hasEnded = true;
    }
    window.trackingEnabled = false;
  },
  onSettingTime() {
    this._metrics('ctl_scrb');
  },
  onVolumeChanged(state) {
    const { currentVolume } = state;
    if(this.prevVolume !== currentVolume) {
      if(currentVolume === 0) {
        this.isMuted = true;
        this._metrics('ctl_mute');
      } else if(this.isMuted) {
        this.isMuted = false;
        this._metrics('ctl_unmute');
      } else {
        this._metrics('ctl_vol');
      }
    }
    this.prevVolume = currentVolume;
  },
  onProgress(state) {
    const { currentTime, duration } = state,
                            percent = (currentTime / duration) * 100;

    [25, 50, 75 ].forEach((i) => {
      if(percent > i && this.percentages[i]) {
        this.percentages[i] = false;
        wmdSetContext('wb.vdname', this.videoUrlFragment);
        addLinkTrackVars('wb.vdname');
        this._metrics(`${i}pct`, {}, '_');
        wmdRemContext('wb.vdname');
        remLinkTrackVars('wb.vdname');
      }
    });
    if(this.isWaiting) {
      this.isWaiting = false;
      this.trackBufferComplete();
    }
    if(percent === 100) {
      window.trackingEnabled = false;
    }
  },
  onClosedCaption(isOpen) {
    if(isOpen) {
      this._metrics('ctl_ccy');
    } else {
      this._metrics('ctl_ccn');
    }
  },
  onFullScreen() {
    if(!this.isFullScreen) {
      this.isFullScreen = true;
      this._metrics('ctl_bigr');
    }
  },
  onExitFullScreen() {
    if(this.isFullScreen) {
      this.isFullScreen = false;
      this._metrics('ctl_smalr');
    }
  },
  initHeartbeat() {
    if(typeof HBT.ADB === 'undefined' || typeof s_md === 'undefined') { // eslint-disable-line
      return;
    }
    // Map values to make code readable;
    const { plugins, HeartbeatDelegate, HeartbeatConfig, Heartbeat } = HBT.ADB.va,
          { AdobeAnalyticsPluginConfig, AdobeAnalyticsPluginDelegate, AdobeAnalyticsPlugin } = plugins.aa,
          { AdobeHeartbeatPluginConfig, AdobeHeartbeatPluginDelegate, AdobeHeartbeatPlugin } = plugins.ah,
          { VideoPlayerPluginConfig, VideoPlayerPluginDelegate, VideoPlayerPlugin, VideoInfo, ChapterInfo } = plugins.videoplayer;

    const analyticsPluginConfig     = new AdobeAnalyticsPluginConfig(),
          analyticsPluginDelegate   = new AdobeAnalyticsPluginDelegate(),
          analyticsPlugin           = new AdobeAnalyticsPlugin(s_md, analyticsPluginDelegate), // eslint-disable-line

          heartbeatPluginConfig     = new AdobeHeartbeatPluginConfig('http://webmd.hb.omtrdc.net', '16AD4362526701720A490D45@AdobeOrg'),
          heartbeatPluginDelegate   = new AdobeHeartbeatPluginDelegate(),
          heartbeatPlugin           = new AdobeHeartbeatPlugin(heartbeatPluginDelegate),

          heartbeatConfig           = new HeartbeatConfig(),
          heartbeatDelegate         = new HeartbeatDelegate(),

          videoPlayerPluginConfig   = new VideoPlayerPluginConfig(),
          videoPlayerPluginDelegate = new VideoPlayerPluginDelegate(); // VideoStore.mediaApi._v.getMediaElement()
          this.VideoPlayerPlugin    = new VideoPlayerPlugin(videoPlayerPluginDelegate);

          this.analyticsPlugin            = analyticsPlugin;
          this.videoPlayerPluginDelegate  = videoPlayerPluginDelegate;

          analyticsPluginConfig.channel   = this.$metrics.prop47;
          heartbeatPluginConfig.sdk       = 'Heartbeats V-1.5.4';

    this.addHeartbeatContext();
    analyticsPluginConfig.debugLogging   = false;
    heartbeatPluginConfig.debugLogging   = false;
    heartbeatConfig.debugLogging         = false;
    videoPlayerPluginConfig.debugLogging = false;
    heartbeatPluginConfig.quietMode      = false;
    this.setVideoMetadata();
    videoPlayerPluginDelegate.getVideoInfo = () => {
      const videoUrlFragment  = get(VideoStore, 'state.meta.videoUrlFragment', `video${(VideoStore.getIndex() + 1)}`),
            info              = new VideoInfo;
            info.id           = `${VideoStore.getSeriesTitle()}/${videoUrlFragment}`;
            info.name         = `video${(VideoStore.getIndex() + 1)}`;
            info.playerName   = 'mtvVideo';
            info.length       = VideoStore.getDuration();
            info.streamType   = 'vod';
            info.playhead     = VideoStore.getCurrentTime() || 0;
            info.friendlyName = VideoStore.getTitle();
      return info;
    };

    videoPlayerPluginDelegate.getChapterInfo = () => {
      const info     = new ChapterInfo();
      info.name      = `video ${(VideoStore.getIndex() + 1)}`;
      info.length    = VideoStore.getDuration();
      info.position  = VideoStore.getCurrentTime();
      info.startTime = 0;
      return info;
    };

    // configure  plugins
    heartbeatPlugin.configure(heartbeatPluginConfig);
    analyticsPlugin.configure(analyticsPluginConfig);
    this.VideoPlayerPlugin.configure(videoPlayerPluginConfig);
    this.heartbeat = new Heartbeat(heartbeatDelegate, [this.VideoPlayerPlugin, analyticsPlugin, heartbeatPlugin]);
    this.heartbeat.configure(heartbeatConfig);
    window.heartbeat = this.heartbeat;

    if(this.isFirstPlay) {
      this.addCtlVideoEvents();
    }
  },
  addCtlVideoEvents() {
    window.onbeforeunload = () => {
      this.VideoPlayerPlugin.trackVideoUnload();
      this.VideoPlayerPlugin.destroy();
    };
    document.querySelector('.akamai-overlays').addEventListener('click', () => {
      VideoActions.pause();
    });

    // Not heartbeat, this is used to track pause and play of the video through omniture.
    VideoStore.mediaApi._v.getMediaElement().addEventListener('pause', ()=> {
      window.video = VideoStore.mediaApi._v.getMediaElement();
      if(isMobile()) {
        VideoActions.pause();
      }
      if(window.trackingEnabled) {
        if(VideoStore.state.event === 'videoSelected') {
          return;
        }
        this._metrics('ctl_pause');
      } else {
        window.trackingEnabled = true;
      }
    });
    VideoStore.mediaApi._v.getMediaElement().addEventListener('webkitendfullscreen', ()=> {
      VideoStore.mediaApi._v.getMediaElement().setAttribute('controls', '');
    });
    VideoStore.mediaApi._v.getMediaElement().addEventListener('play', ()=> {
      if(window.trackingEnabled) {
        if(VideoStore.state.event === 'videoSelected') {
          return;
        }
        this._metrics('ctl_play');
      } else {
        window.trackingEnabled = true;
      }
    });
    VideoStore.mediaApi._v.getMediaElement().addEventListener('click', ()=> {
      if(window.trackingEnabled) {
        if(VideoStore.state.event === 'videoSelected') {
          return;
        }
        if(VideoStore.mediaApi._v.getMediaElement().paused === true) {
          this._metrics('ctl_play');
        }
      } else {
        window.trackingEnabled = true;
      }
    });
  },
  /**
   * @param name    - the link name, to be appended to `vidcme`
   * @param options - props to be passed through to the beacon, e.g. prop9, etc. . .
   * @param sep     - due to inconsistencies in the tracking spec, some values are
   *                  separated by a hyphen and others by an underscore. This is
   *                  appears to be arbitrary.
   */
  _metrics(name, options={ }, sep='-') {
    if(remLinkTrackVars && s_md.linkTrackVars.indexOf('a.media') !== -1) {
      remLinkTrackVars(this.contextDataVars.toString());
    }
    const opts = defaults(options, { prop24: s_pageview_id || '' }),
          link = `vidmtv${sep}${name}`;
    this.pageLink(link, opts);
  },
  pageLink(link, obj) {
    if(typeof addLinkTrackVars === 'undefined') return;
    addLinkTrackVars(keys(obj));
    try {
      assign(s_md, obj);
      wmdPageLink(link);
    } finally {
      remLinkTrackVars(keys(obj));
    }
  },
  addHeartbeatContext() {
    if(typeof addLinkTrackVars === 'undefined') {
      return;
    } else {
      addLinkTrackVars(this.contextDataVars.toString());
    }
  },
  remHeartbeatContext() {
    if(typeof addLinkTrackVars === 'undefined') {
      return;
    } else {
      remLinkTrackVars(this.contextDataVars.toString());
    }
  }
});



/** WEBPACK FOOTER **
 ** ./modules/stores/tracking_store.js
 **/